import { runtimeEnv } from 'config/runtimeEnv';
import { setCurrentUser } from 'utils/utils';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
let env = runtimeEnv('B2B_API_BASE_URL');

export const allotVehicle = async (data) => {
  const res = await requestInstance
    .put(`${env}${API_ENDPOINT.operations.allotApi}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const availableVehicleService = async (payload) => {
  const payloadData = {
    search: payload?.search || '',
    id: payload?.id,
  };

  let url = '';
  if (payload?.id) {
    url = `${env}${API_ENDPOINT.operations.availableVehicleApi}?tripId=${payloadData?.id}&isB2B=true&search=${payloadData?.search}`;
  } else {
    url = `${env}${API_ENDPOINT.operations.availableVehicleApi}?tripId=${payload}&isB2B=true`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const availableSupplierService = async (payload) => {
  const payloadData = {
    search: payload?.search || '',
    id: payload?.id,
  };

  let url = '';
  if (payload?.id) {
    url = `${env}${API_ENDPOINT.operations.availableSuppliersApi}?tripId=${payloadData?.id}&isB2B=true&search=${payloadData?.search}`;
  } else {
    url = `${env}${API_ENDPOINT.operations.availableSuppliersApi}?tripId=${payload}&isB2B=true`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const dispatchVehicleService = async (data) => {
  const res = await requestInstance
    .put(`${env}${API_ENDPOINT.operations.dispatchApi}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const cancelTripService = async (data) => {
  const val = {
    cancelReason: data?.reason,
  };
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.operations.cancelTrip}${data?.id}`, val)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const cancelationChargesService = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.operations.cancelTrip}${data}/charges`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
export const assignSubVendorService = async (data) => {
  const res = await requestInstance
    .put(`${env}${API_ENDPOINT.AssignVehicle.assignSubVendorApi}?isB2B=true`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const reAssignDriverService = async (payload) => {
  const res = await requestInstance
    .put(`${env}${API_ENDPOINT.AssignVehicle.reAssignDriver}`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
